/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Stripedescription1Inputs */

const zh_billing_stripedescription1 = /** @type {(inputs: Billing_Stripedescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在 Stripe 账单门户中管理付款方式、查看发票和下载收据。`)
};

const en_billing_stripedescription1 = /** @type {(inputs: Billing_Stripedescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage payment methods, view invoices, and download receipts in the Stripe billing portal.`)
};

const es_billing_stripedescription1 = /** @type {(inputs: Billing_Stripedescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestiona métodos de pago, consulta facturas y descarga recibos en el portal de facturación de Stripe.`)
};

/**
* | output |
* | --- |
* | "Manage payment methods, view invoices, and download receipts in the Stripe billing portal." |
*
* @param {Billing_Stripedescription1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const billing_stripedescription1 = /** @type {((inputs?: Billing_Stripedescription1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Stripedescription1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_billing_stripedescription1(inputs)
	if (locale === "en") return en_billing_stripedescription1(inputs)
	return es_billing_stripedescription1(inputs)
});
export { billing_stripedescription1 as "billing_stripeDescription" }